import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-casino',
  templateUrl: './casino.component.html',
  styleUrls: ['./casino.component.css'],
  host: {
    "(window:resize)": "onWindowResize($event)"
  }
})
export class CasinoComponent extends BaseClass<any> implements OnInit {

  @ViewChild('parentTabs', { static: false }) parentTabs?: TabsetComponent;
  @ViewChild('childTabs', { static: false }) childTabs?: TabsetComponent;

  @Input() casinoId!: any;
  @Input() isDashboard: boolean = false;

  public isMobile: boolean = false;
  public data: any;
  public id: any;
  public key: any;
  public checkKey: boolean = false;

  constructor(
    public service: WebserviceService,
    public router: Router,
    protected actRoute: ActivatedRoute,
    public _common: CommonService,
    public _message: MessageService,
  ) {
    super();
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));

    let idstring = this.actRoute.snapshot.paramMap.get('id') ? this.actRoute.snapshot.paramMap.get('id') : ''
    this.key = idstring?.split(':')[idstring?.split(':').length - 1];
    if (idstring?.split(':')[1]) {
      this.id = Number(idstring?.split(':')[0]);
    }
  }

  width: number = window.innerWidth;
  mobileWidth: number = 768;
  onWindowResize(event: any) {
    this.width = event.target.innerWidth;
    this.isMobile = this.width < this.mobileWidth ? true : false;
  }

  ngOnInit(): void {
    this.getData();
    if (!this.isDashboard) {
      this.onRoutChange();
    }
  }

  onRoutChange() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {

        if (this.id != this.actRoute.snapshot.paramMap.get('id')) {
          this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
          this.getData();
        }
      }
    })
  }

  tabId = 0;
  onSelect(id: any): void {
    this.tabId = id;
    if (this.childTabs?.tabs[id]) {
      this.childTabs.tabs[id].active = true;
    }
  }
  pTabId = 0;
  onSelectParent(id: any): void {
    this.pTabId = id;
    if (this.parentTabs?.tabs[id]) {
      this.parentTabs.tabs[id].active = true;
    }
    this.onSelect(0);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.pTabId = 0;
    this.tabId = 0;
    this.isLoad = true;
    let api: any;
    if (this.isLogin()) {
      api = this.events.casino1.includes(this.id) ? this.api.casino1 : this.events.iCasino.includes(this.id) ? this.api.casinoIList : this.events.intCasino.includes(this.id) ? this.api.casinoIntList : '';
    } else {
      api = this.events.casino1.includes(this.id) ? this.api.casino1G : this.events.iCasino.includes(this.id) ? this.api.casinoIListG : this.events.intCasino.includes(this.id) ? this.api.casinoIntListG : '';
    }

    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res && res.status == true) {
          if (this.events.casino1.includes(this.id)) {
            this.setCasino1(res);
          } else if (this.events.iCasino.includes(this.id)) {
            this.setICasino(res);
            //this.setICasinoNew(res);
            // this.setIntCasino(res);
            if (this.key && this.key != null) {
              this.openFilteredTab(this.data)
            }
          } else if (this.events.intCasino.includes(this.id)) {
            this.setIntCasino(res);
          }


        } else if (res && res.status == false) {
          if (this.router.url.includes('/casino')) {
            this._message.errmessage(res?.error?.message);
            this.router.navigate([`${this.isMobile ? '/dashboard' : '/dashboard'}`])
          }
          this.data = []
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  setCasino1(res: any) {
    this.data = res.data;
  }

  setICasinoNew(res: any) {
    let allDt: any[] = [];
    Object.keys(res.data.allTables).forEach((key) => {
      allDt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': res.data.allTables[key]
      });
    });
    let dt: any[] = [];
    Object.keys(res.data.tables).every((key) => {
      let dataDt: any[] = [];
      Object.keys(res.data.tables[key]).forEach((key1) => {
        let dataDtInner: any[] = [];
        let allDataDtInner: any[] = [];
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          allDataDtInner = [...allDataDtInner, ...res.data.tables[key][key1][key2]]
          dataDtInner.push({
            'name': key2,
            'slug': key2.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
            'data': res.data.tables[key][key1][key2]
          });
        });
        // console.log(allDataDtInner);
        dataDtInner.unshift({ name: 'all', slug: 'all', data: allDataDtInner });

        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': dataDtInner
        });
      });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
      return false; // break (break foreach loop after first iteration)
    });
    res.data.tables = dt;
    this.data = res.data.tables[0]['data'];
    this.data.unshift({ name: 'all', slug: 'all', data: allDt });
  }

  setICasino(res: any) {
    let allDt: any[] = [];
    let allDtGameTyes: any[] = [];
    let dt: any[] = [];
    Object.keys(res.data.providers).forEach((key) => {
      let dataDt: any[] = [];
      let allDataDtInner: any[] = [];
      Object.keys(res.data.providers[key]).forEach((key1) => {
        allDataDtInner = [...allDataDtInner, ...res.data.providers[key][key1]];
        allDt = [...allDt, ...res.data.providers[key][key1]];
        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': res.data.providers[key][key1]
        });
      });
      dataDt.unshift({ name: 'all', slug: 'all', data: allDataDtInner });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    allDtGameTyes = allDt.map(item => item.game_type);
    const uniqueSet = new Set(allDtGameTyes);
    allDtGameTyes = [...uniqueSet];

    let finalAllDt: any[] = [];
    allDtGameTyes.forEach(element => {
      finalAllDt.push({
        'name': element,
        'slug': element.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': allDt.filter(e => e.game_type == element)
      });
    });

    dt.unshift({ name: 'all', slug: 'all', data: finalAllDt });
    res.data.providers = dt;
    this.data = res.data.providers;

    if (this.key && this.key != null) {
      this.openFilteredTab(this.data)
    }

  }

  setIntCasino(res: any) {

    let allDt: any[] = [];
    Object.keys(res.data.allTables).forEach((key) => {
      allDt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': res.data.allTables[key]
      });
    });

    //console.log(res.data.tables);
    let dt: any[] = [];
    Object.keys(res.data.tables).forEach((key) => {
      let dataDt: any[] = [];
      Object.keys(res.data.tables[key]).forEach((key1) => {
        let dataDtInner: any[] = [];
        let allDataDtInner: any[] = [];
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          allDataDtInner = [...allDataDtInner, ...res.data.tables[key][key1][key2]]
          dataDtInner.push({
            'name': key2,
            'slug': key2.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
            'data': res.data.tables[key][key1][key2]
          });
        });
        // console.log(allDataDtInner);
        dataDtInner.unshift({ name: 'all', slug: 'all', data: allDataDtInner });

        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': dataDtInner
        });
      });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    res.data.tables = dt;
    this.data = res.data.tables[0]['data'];
    this.data.unshift({ name: 'all', slug: 'all', data: allDt });
    //console.log(this.data);
  }

  openFilteredTab(data: any) {
    if (data) {
      let res = data;
      //console.log(data);
      res.forEach((element: any, i: any) => {
        //console.log(element.slug.toUpperCase());
        if (element.slug.toUpperCase().includes(this.key.toUpperCase())) {
          this.pTabId = i;
          this.tabId = 0;
          this.checkKey = true;
          this.onSelectParent(i);
          this.onSelect(0);
        }
      });
    }
  }

  confirmCasinoDetail(mn_id: any, game_id: any) {
    if (this.isLogin()) {
      this.router.navigate(['/casino-detail', mn_id, game_id]);
    } else {
      this._common.openModalWithComponent('', LoginComponent, 'loginpopup')
    }
  }

  confirmLogin(item: any) {
    if (this.isLogin()) {
      // this.router.navigate([`/casino-detail`, this.id, (this.data?.launch_ids) ? this.data?.launch_ids[item.id] : item.id]);
      this.router.navigate([`/casino-detail`, this.id, item.id]);
    } else {
      this._common.openModalWithComponent('', LoginComponent, 'loginpopup')
    }
  }

  // confirmBox(item: any, name: any) {
  //   if (this.isLogin()) {
  //     let msg = `Profit & Loss in iCasino would be ${item?.multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${item?.multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${item?.multiplier}.`;
  //     // <br> Please note(1 Point = ${item?.multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${item?.multiplier} अंक)
  //     Swal.fire({
  //       title: 'DO YOU AGREE?',
  //       html: msg,
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonText: 'Yes, I Agree',
  //       cancelButtonText: 'No, I dont Agree'
  //     }).then((result) => {
  //       if (result.value) {
  //         this.router.navigate([`/casino-detail`, this.id, item.id]);
  //       } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       }
  //     })
  //     // this.router.navigate([`/casino-detail`, this.id, item.id]);
  //   } else {
  //     this._common.openModalWithComponent('', LoginComponent, 'loginpopup')
  //   }
  // }
  confirmBox(item: any, name: any) {
    if (this.isLogin()) {
      let msg = `<img style="width:100%;" src="https://speedcdn.io/assets/parker-client/int-modal-popup.jpg"/>`;
      Swal.fire({
        // title: 'DO YOU AGREE?',
        html: msg,
        // icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate([`/casino-detail`, this.id, item.id]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
      // this.router.navigate([`/casino-detail`, this.id, item.id]);
    } else {
      this._common.openModalWithComponent('', LoginComponent, 'loginpopup')
    }
  }

  getImagePath(item: any) {
    // return `assets/img/casino1/${item?.id}.webp`;
    return `https://speedcdn.io/assets/parker-client/casinogames/${item?.id}.webp`;
  }

  ngOnChanges() {
    if (this.events.casino.includes(this.casinoId)) {
      this.id = this.casinoId;
    }
  }

  ngDoCheck() {
    let idstring = this.actRoute.snapshot.paramMap.get('id') ? this.actRoute.snapshot.paramMap.get('id') : ''
    this.key = idstring?.split(':')[idstring?.split(':').length - 1];

    if (this.checkKey == true && (this.parentTabs && this.parentTabs?.tabs?.length > 0) && (this.childTabs && this.childTabs?.tabs?.length > 0)) {
      this.onSelectParent(this.pTabId);
      this.onSelect(this.tabId);
      //this.gotoDiv(`goto-casino-${this.pTabId}-link`)
      //this.gotoDiv(`goto-casino-${this.pTabId}${this.tabId}-link`)
      this.checkKey = false;
    }
  }
}
